<template>
    <form-row title="Who is Holding Earnest Money?" class="-mt-2">
        <div class="flex-1">
            <input-radio-multi
                class="mt-2"
                label="For the Buyer:"
                name="holding_earnest_money_buyers"
                :value="deal.holding_earnest_money_buyers"
                :options="earnest_money_options"
                :vertical="true"
                :nullable="true"
                :read_only="read_only"
            />
        </div>

        <div class="flex-1">
            <input-radio-multi
                class="mt-6 sm:mt-2"
                label="For the Seller:"
                name="holding_earnest_money_sellers"
                :value="deal.holding_earnest_money_sellers"
                :options="earnest_money_options"
                :vertical="true"
                :nullable="true"
                :read_only="read_only"
            />
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            earnest_money_options: store.state.tenant === 'ng'
                ? [
                    { label: 'Real Estate Company', value: 'Real Estate Company' },
                    { label: 'Lawyer', value: 'Lawyer' },
                    { label: 'Bank', value: 'Bank' },
                ]
                : [
                    { label: 'Real Estate Company', value: 'Real Estate Company' },
                    { label: 'Title Company', value: 'Title Company' },
                    { label: 'Escrow Company', value: 'Escrow Company' },
                ],
        }
    },

}
</script>
